import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";

import { MatchMaker } from "@hub/pages/MatchMaker";

const Details = lazy(() => import("@hub/pages/Details"));
const Offers = lazy(() => import("@hub/pages/Offers"));
const PreApprovedOffers = lazy(() => import("@hub/pages/PreApprovedOffers"));
const TicketApprovedOffers = lazy(
	() => import("@hub/pages/TicketApprovedOffers"),
);
const FullFunnelRedirect = lazy(() => import("@hub/pages/FullFunnelRedirect"));

export function HubPrivateRouter() {
	return (
		<>
			<Route path="ofertas" element={<Offers />} />
			<Route path="oferta-detalhada/:slug" element={<Details />} />
			<Route path="comparador" element={<MatchMaker />} />
			<Route path="ofertas-pre-aprovadas" element={<PreApprovedOffers />} />
			<Route
				path="ofertas-selecionadas-ticket"
				element={<TicketApprovedOffers />}
			/>
			<Route path="analisando-oferta" element={<FullFunnelRedirect />} />
			<Route path="meus-favoritos" element={<Navigate to="/home" replace />} />
		</>
	);
}
